export default "__VITE_PUBLIC_ASSET__32f819ae__"